module.exports = __webpack_public_path__ + "img/kanban_snap.89e735e9.png";